import { Save, Undo, Redo } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Textarea } from '@/components/ui/textarea';

interface PromptEditorProps {
  prompt: any;
  onChange: (value: any) => void;
  onSave: (e: any) => void;
}

const PromptEditor = ({ prompt, onChange, onSave }: PromptEditorProps) => {
  return (
    <Card className="flex flex-col h-full p-0 m-0 border-none">
      <CardHeader className="flex flex-row items-center justify-between pb-2 space-y-0">
        <div className="">
          <CardTitle>Prompt Editor</CardTitle>
          <CardDescription>
            Edit the prompt for your campaign. Use the available variables to personalize your message.
          </CardDescription>
        </div>
        <div className="space-x-2">
          <Button variant="outline" size="icon">
            <Undo className="w-4 h-4" />
          </Button>
          <Button variant="outline" size="icon">
            <Redo className="w-4 h-4" />
          </Button>
          <Button onClick={onSave}>
            <Save className="w-4 h-4 mr-2" />
            Save Version
          </Button>
        </div>
      </CardHeader>
      <CardContent className="flex-1">
        <div className="relative h-full">
          <Textarea
            value={prompt.content}
            onChange={onChange}
            placeholder="Enter your prompt here..."
            className="h-full font-mono resize-none"
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default PromptEditor;
